<template>
  <div class="custom-select" :tabindex="tabindex" @blur="open = false">
    <div class="selected" :class="{ open: open }" @click="open = !open">
      <span class="selected_value">{{ value ? value : def }}</span>
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <div
        v-for="(option, i) of options"
        :key="i"
        @click="
          selected = option;
          open = false;
          $emit('update:modelValue', option);
        "
      >
        {{ option }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    def: {
      type: String,
      required: false,
      default: null,
    },
    value: {
        type: String,
        required: false,
        default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
        selected: this.def
            ? this.value ? this.value : this.def
            : this.options.length > 0
            ? this.options[0]
            : null,
        open: false,
    };
  },
  mounted() {
    if (this.selected !== this.def) {
     this.$emit("update:modelValue", this.selected); 
    }
  },
};
</script>

<style scoped>
.custom-select {
    position: relative;
    width: 100%;
    text-align: left;
    outline: none;
}

.custom-select .selected {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-right: 30px;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z' fill='%23356EEF'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 12px 7px;
    border: none;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    cursor: pointer;
    user-select: none;
}

.custom-select .items {
    padding-top: 10px;
    padding-bottom: 5px;
    margin-top: 5px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    overflow: hidden;
    position: absolute;
    background-color: #ffff;
    left: 0;
    right: 0;
    z-index: 1;
    border-radius: 6px;
    overflow: hidden;
    border-right: 1px solid #DEE2E6;
    border-left: 1px solid #DEE2E6;
    border-bottom: 1px solid #DEE2E6;
    box-shadow: 0 2px 4px -1px rgb(0 0 0 / 20%), 0 4px 5px 0 rgb(0 0 0 / 14%), 0 1px 10px 0 rgb(0 0 0 / 12%);
    max-height: 200px;
    overflow: auto;
}

.custom-select .items div {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    padding-left: 1em;
    cursor: pointer;
    user-select: none;
    margin-bottom: 5px;
}

.custom-select .items div:hover {
  background-color: #356EEF;
  color: #ffff;
}

.selectHide {
  display: none;
}
</style>